import React, {Component} from 'react'
import {createNewBox} from "../../../services/api/apiNextBox"
import getHistory from "../../../getHistory"


class CreateNewBoxFBA extends Component {
    state = {
        loading: false,
    }

    _handleClick = e => {
        e.preventDefault()

        return this._createNewBox()
    }

    _createNewBox = async () => {
        if (this.state.loading) return true

        this.setState({
            loading: true
        })

        try {
            const type = 'FBA'
            const {success, data, message} = await createNewBox(type)

            if (!success) {
                throw new Error(message)
            }

            const {_id} = data
            const history = getHistory()
            history.push(`/next-boxes-fba/${_id}`)
        } catch (e) {
            this.setState({loading: false}, () => {
                window.alert('Lỗi: ' + e.message)
            })
        }

    }

    render() {
        const {loading} = this.state

        return (
            <div className="CreateNewBox ml-3">
                <button 
                    disabled={loading} 
                    onClick={this._handleClick} 
                    className="btn btn-secondary"
                    style={{background: 'orange'}}
                >
                    Tạo thùng FBA
                </button>
            </div>
        )
    }
}

export default CreateNewBoxFBA
